import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { createWarning } from '@core/helpers/create-validator.helper';
import { toNum } from '@shared/helpers/math.helper';

@Injectable()
export class ScopoSocialeWarningsService {
    constructor(private readonly store: Store<Revisione53State>) {}

    patrimonioNettoNeg = createWarning(this.store, (myVerbale) => {
        const datiBilancio = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio;
        const my_StPaPsAtot2 = toNum(datiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot2);

        if (my_StPaPsAtot2 < 0) {
            return 'Il patrimonio netto è negativo';
        }

        return null;
    });

    opportuneValutazioniIndici = createWarning(this.store, (myVerbale) => {
        const datiBilancio = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio;
        const my_StPaAtDtot2 = toNum(datiBilancio.my_StatoPatrimoniale__Attivo.my_StPaAtDtot2);
        const my_StPaPsEtot2 = toNum(datiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsEtot2);

        if (my_StPaAtDtot2 > 0 || my_StPaPsEtot2 > 0) {
            return 'Attenzione, si facciano opportune valutazioni sugli indici valutando i ratei e i risconti presenti nel bilancio e la loro rilevanza e tenendo conto del fatto che essi sono utilizzati per il calcolo dei crediti e debiti a breve termine';
        }

        return null;
    });

    warning = createWarning(this.store, (myVerbale) => {
        const datiBilancio = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio;
        const raggScopoSociale = myVerbale.my_SezioneI__Rilevazione.my_RaggScopoSociale;
        const my_AttivoCirc = toNum(raggScopoSociale.my_AttivoCirc);
        const my_StPaPsAtot2 = toNum(datiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot2);

        if (!(my_AttivoCirc >= 0 && my_StPaPsAtot2 >= 0)) {
            return 'Attenzione!';
        }

        return null;
    });

    my_AttivoCorrNetto = createWarning(this.store, (myVerbale) => {
        const raggScopoSociale = myVerbale.my_SezioneI__Rilevazione.my_RaggScopoSociale;
        const my_AttivoCirc = toNum(raggScopoSociale.my_AttivoCirc);
        const my_PassivBreve = toNum(raggScopoSociale.my_PassivBreve);

        if (my_AttivoCirc - my_PassivBreve < 0) {
            return 'Il capitale circolante netto è negativo';
        }

        return null;
    });

    my_MargTesoreria = createWarning(this.store, (myVerbale) => {
        const raggScopoSociale = myVerbale.my_SezioneI__Rilevazione.my_RaggScopoSociale;
        const my_AttivoCirc = toNum(raggScopoSociale.my_AttivoCirc);
        const my_rimanenze = toNum(raggScopoSociale.my_rimanenze);
        const my_PassivBreve = toNum(raggScopoSociale.my_PassivBreve);

        if (my_AttivoCirc - my_rimanenze - my_PassivBreve < 0) {
            return 'Il capitale circolante netto rettificato è negativo';
        }

        return null;
    });
}
